<template>
  <div>
    <c-form>
      <c-title>Passwort erfolgreich geändert</c-title>

      <div class="success-message">
        <p>Ihr Passwort wurde erfolgreich aktualisiert.</p>
      </div>

      <div class="button-container">
        <c-button type="button" @click="goToDashboard">
          Weiter zum Dashboard
        </c-button>

        <c-button 
          @click="logout"
          :busy="logoutStatus === $config.status.LOADING"
        >
          Abmelden
        </c-button>
      </div>
    </c-form>
  </div>
</template>

<script>
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CTitle from '@/components/CTitle'

import sessionToken from '@/functions/sessionToken'
import handleRequestError from '@/functions/handleRequestError'

export default {
  name: 'VPasswordChangeSuccess',

  components: {
    CButton,
    CForm,
    CTitle
  },

  data () {
    return {
      logoutStatus: this.$config.status.IDLE
    }
  },

  methods: {
    async goToDashboard () {
      try {
        await this.$api.post('auth/validate/')
        this.$router.push({ name: 'dashboard' })
      } catch (error) {
        this.$store.commit('notifications/add', {text: 'Bitte melden Sie sich erneut an.',type: 'error'})
        this.$router.push({ name: 'login' })
      }
    },

    logout () {
      this.logoutStatus = this.$config.status.LOADING

      this.$api.post('auth/logout/')
        .then(() => {
          sessionToken.remove()
          this.$store.commit('user/reset')
          
          this.$store.commit('notifications/add', {
            text: 'Sie wurden erfolgreich abgemeldet.',
            type: 'success'
          })

          this.$router.push({ name: 'login' })
        })
        .catch(error => {
          this.logoutStatus = this.$config.status.ERROR
          
          handleRequestError({
            error,
            fallback: 'Es ist ein Fehler beim Abmelden aufgetreten.'
          })
        })
    }
  }
}
</script>

<style scoped>
.success-message {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 20px;
  color: #155724;
}

.success-message p {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.info-notice {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 16px;
  margin-top: 20px;
}

.info-notice p {
  margin: 0;
  color: #856404;
  font-size: 14px;
  line-height: 1.5;
}

.info-notice a {
  color: #856404;
  text-decoration: underline;
}

.info-notice a:hover {
  color: #533f03;
}

@media (min-width: 576px) {
  .button-container {
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
